
import { ButtonGroup, ToggleButton } from "react-bootstrap";


const AdminEditTypeSelect = ({ selectedEditType, handleEditTypeChanged, practiceName, disabled}) => {
  return (
      <ButtonGroup className="me-auto">
          <ToggleButton
              disabled={disabled}
              size="sm"
              key="PRACTICE"
              id="PRACTICE"
              type="radio"
              variant="outline-primary"
              style={{color: selectedEditType === "PRACTICE" ? "white" : ""}}
              value="PRACTICE"
              checked={selectedEditType === "PRACTICE"}
              onChange={(e) => {handleEditTypeChanged(e.target.value)}}
          >{practiceName}</ToggleButton>
          <ToggleButton
              disabled={disabled}
              size="sm"
              key="GLOBAL"
              id="GLOBAL"
              type="radio"
              variant="outline-primary"
              style={{color: selectedEditType === "GLOBAL" ? "white" : ""}}
              value="GLOBAL"
              checked={selectedEditType === "GLOBAL"}
              onChange={(e) => {handleEditTypeChanged(e.target.value)}}
          >Global</ToggleButton>
      </ButtonGroup>
  )
}
  
  
  export default AdminEditTypeSelect;